export default __webpack_public_path__ + "static/media/node_red_01.0baa8de2.jpg";